export const LINKS_TITLE = {
	IR_PARA_MUVIFLEX: 'Ir para Muviflex',
	FATURAS: 'Faturas',
	REDEFINIR_SENHA_MUVICARD: 'Redefinir senha Muvicard',
	BLOQUEAR_DESBLOQUEAR_CARTAO: 'Bloquear/ Desbloquear cartão',
	CANCELAR_CARTAO: 'Cancelar cartão',
	CARTAO_MUVICARD: 'Cartão Muvicard',
	PERGUNTAS_FREQUENTES: 'Perguntas frequentes',
	BLOG: 'Blog',
	LOJA: 'Loja',
	FALE_CONSOCE: 'Fale Conosco',
	COMPRE_VIA_WHATS: 'Compre via Whats',
	COMPRA_DE_PONTOS: 'Compra de pontos',
	COMPRAR_PONTOS: 'Comprar pontos',
	PONTOS_DE_PRESENTE: 'Pontos de presente',
	PONTOS_PRESENTES: 'Pontos presente',
	EXTRATO_DE_PONTOS: 'Extrato de Pontos',
	MINHAS_COMPRAS: 'Minhas Compras',
	MINHA_CONTA: 'Minha Conta',
	ACESSIBILIDADE: 'Acessibilidade',
	COMPRE_E_GANHE: 'Compre e Ganhe',
	CONVIDAR_AMIGOS: 'Convidar amigos',
	CLUBE_MUVIFLEX: 'Clube Muviflex',
	SOLICITAR_PONTOS: 'Solicitar pontos',
	ADMINISTRACAO_MUVIFLEX: 'Administração Muviflex',
	ADMINISTRACAO_PARCEIRO: 'Administração Parceiro',
	FINANCEIRO: 'Financeiro',
	CRIAR_PONTOS: 'Criar pontos',
	MOVIMENTAR_PONTOS: 'Movimentar pontos',
	CLIENTES: 'Clientes',
	FUNCIONARIOS: 'Funcionários',
	CUPONS_DE_DESCONTO: 'Cupons de desconto',
	LOJA_MUVIFLEX: 'Loja Muviflex',
	RELATORIOS: 'Relatórios',
	BREAKAGE_DE_PONTOS: 'Breakage de pontos',
	VENDAS_FATURAMENTO: 'Vendas/Faturamento',
	PASSAGENS_VENDIDAS: 'Passagens Vendidas',
	SOLICITACOES_DE_CARTAO: 'Solicitações de Cartão',
	MEU_PLANO: 'Meu plano',
	HISTORICO: 'Histórico',
	CONVIDE_SEUS_AMIGOS: 'Convide seus amigos',
	SOLICITACAO_DE_PONTOS: 'Solicitação de pontos',
	MEUS_DADOS: 'Meus dados',
	INSTITUCIONAL: 'Institucional',
}

export const FORBIDDEN_TO_PUBLIC_BODY = [
	LINKS_TITLE.LOJA,
	LINKS_TITLE.COMPRA_DE_PONTOS,
	LINKS_TITLE.PONTOS_DE_PRESENTE,
	LINKS_TITLE.EXTRATO_DE_PONTOS,
]
